export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "order": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pedido"])},
            "order_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "ordered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de pedido"])},
            "delivered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de entrega"])},
            "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
            "delivery_process_customer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliente"])},
            "statuses": {
              "pending": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pendiente"])},
                "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["text-gray-800"])},
                "bg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bg-gray-100"])}
              },
              "cancelled": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelado"])},
                "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["text-red-800"])},
                "bg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bg-red-100"])}
              },
              "delivered": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entregado"])},
                "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["text-green-800"])},
                "bg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bg-green-100"])}
              },
              "in_route": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En ruta"])},
                "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["text-blue-800"])},
                "bg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bg-blue-100"])}
              }
            }
          }
        }
      }
    }
  })
}